.phone-input-container {
  width: 100%;
  padding: 0 0.5rem;
  box-sizing: border-box;
}

.phone-input-wrapper {
  display: flex;
  align-items: stretch;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
}

.phone-input {
  flex: 1;
  min-width: 0;
  padding: 0.8em 1.6em;
  font-size: 1.2em;
  font-family: inherit;
  border: 2px solid #464e58;
  border-radius: 10px;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  box-sizing: border-box;
}

.phone-input:focus {
  border-color: #252c82;
  box-shadow: 0 0 0 3px rgba(37, 44, 130, 0.15);
}

.phone-input:disabled {
  background-color: #f3f4f6;
  cursor: not-allowed;
  opacity: 0.7;
}

.phone-input::placeholder {
  color: #71727a;
}

.phone-input.has-error {
  border-color: #ff5353;
}

.phone-input.has-error:focus {
  border-color: #ff5353;
  box-shadow: 0 0 0 3px rgba(255, 83, 83, 0.15);
}

.validation-error {
  margin-top: 8px;
  padding: 8px 12px;
  background-color: #fff5f5;
  border: 1px solid #ffcaca;
  border-radius: 8px;
  color: #ff5353;
  font-size: 0.85rem;
  line-height: 1.4;
}

.full-phone-display {
  margin-top: 12px;
  padding: 10px 14px;
  background-color: #f5faf0;
  border: 1px solid #c5e4a3;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
}

.full-phone-label {
  color: #5a8a08;
  font-weight: 500;
}

.full-phone-number {
  color: #7bb40e;
  font-weight: 600;
  font-family: 'Roboto', sans-serif;
  letter-spacing: 0.5px;
}

.button-container {
  width: 100%;
  padding: 0 0.5rem;
  position: relative;
  box-sizing: border-box;
}

.main-button {
  background: #7bb40e;
  border-radius: 50px;
  text-align: center;
  width: 100%;
  padding: 0.9em;
  color: #fff;
  border: 0;
  font-size: 1.1em;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.1s ease;
  box-sizing: border-box;
}

.main-button:hover:not(:disabled) {
  background: #6a9e0c;
}

.main-button:active:not(:disabled) {
  transform: scale(0.98);
}

.main-button:disabled {
  color: #fff;
  background: #bdbdbd;
  cursor: not-allowed;
}

.main-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(123, 180, 14, 0.3);
}

@media (min-width: 768px) {
  .phone-input-container,
  .button-container {
    padding: 0 1rem;
  }

  .phone-input {
    font-size: 1.1em;
  }
}

@media (max-width: 480px) {
  .phone-input {
    font-size: 1em;
    padding: 0.7em 1.2em;
  }

  .full-phone-display {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .main-button {
    padding: 0.8em;
    font-size: 1em;
  }

  .validation-error {
    font-size: 0.8rem;
  }
}

@media (max-width: 320px) {
  .phone-input-container,
  .button-container {
    padding: 0 0.25rem;
  }

  .phone-input {
    font-size: 0.9em;
    padding: 0.6em 1em;
  }

  .full-phone-display {
    padding: 8px 10px;
    font-size: 0.8rem;
  }

  .validation-error {
    font-size: 0.75rem;
    padding: 6px 10px;
  }

  .main-button {
    padding: 0.7em;
    font-size: 0.95em;
  }
}
